
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    svg: { type: String, required: true },
    to: { type: String, required: true }
  }
})
